import {
  activityFeed,
  adminBrokerAccount,
  brokerConnections,
  riskControls,
  strategies,
  summaryCards,
  users
} from '../data/mockData';

function OverviewPage() {
  return (
    <>
      <section className="panel-section">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Section 1</p>
            <h3>User Management</h3>
          </div>
        </div>

        <div className="summary-grid">
          {summaryCards.map((card) => (
            <article key={card.label} className="summary-card">
              <span>{card.label}</span>
              <strong>{card.value}</strong>
              <p>{card.detail}</p>
            </article>
          ))}
        </div>

        <div className="table-card">
          <div className="card-header">
            <div>
              <h4>Basic user details</h4>
              <p>Name, registration, login history, subscription, and account control.</p>
            </div>
            <button type="button" className="primary-button compact">
              Approve Selected
            </button>
          </div>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Registration</th>
                  <th>Last Login</th>
                  <th>IP Address</th>
                  <th>Status</th>
                  <th>Subscription</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id}>
                    <td>
                      <strong>{user.name}</strong>
                      <span className={`status-pill ${user.approval.toLowerCase()}`}>
                        {user.approval}
                      </span>
                    </td>
                    <td>{user.email}</td>
                    <td>{user.phone}</td>
                    <td>{user.registrationDate}</td>
                    <td>{user.lastLogin}</td>
                    <td>{user.ipAddress}</td>
                    <td>{user.status}</td>
                    <td>
                      {user.subscriptionType}
                      <small>
                        {user.subscriptionStart} to {user.subscriptionEnd}
                      </small>
                    </td>
                    <td>
                      <div className="action-group">
                        <button type="button" className="ghost-button compact">
                          Enable/Disable
                        </button>
                        <button type="button" className="ghost-button compact">
                          Suspend
                        </button>
                        <button type="button" className="ghost-button compact">
                          Force Logout
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="panel-section two-column">
        <div className="table-card">
          <div className="card-header">
            <div>
              <p className="eyebrow">Section 2</p>
              <h4>Broker Authentication</h4>
            </div>
          </div>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>User</th>
                  <th>Fyers Client ID</th>
                  <th>Redirect URL</th>
                  <th>Token Status</th>
                  <th>Token Expiry</th>
                  <th>Last Authentication</th>
                  <th>Admin Actions</th>
                </tr>
              </thead>
              <tbody>
                {brokerConnections.map((connection) => (
                  <tr key={connection.id}>
                    <td>{connection.user}</td>
                    <td>{connection.clientId}</td>
                    <td>{connection.redirectUrl}</td>
                    <td>
                      <span
                        className={`status-pill ${connection.tokenStatus
                          .toLowerCase()
                          .replace(/\s+/g, '-')}`}
                      >
                        {connection.tokenStatus}
                      </span>
                    </td>
                    <td>{connection.tokenExpiry}</td>
                    <td>{connection.lastAuthentication}</td>
                    <td>
                      <div className="action-group">
                        <button type="button" className="ghost-button compact">
                          Revoke Token
                        </button>
                        <button type="button" className="ghost-button compact">
                          Re-Auth
                        </button>
                        <button type="button" className="ghost-button compact">
                          Check Status
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="stack-column">
          <article className="info-card">
            <p className="eyebrow">Internal Data Account</p>
            <h4>Admin Fyers connection</h4>
            <ul className="meta-list">
              <li>
                <span>Admin Client ID</span>
                <strong>{adminBrokerAccount.clientId}</strong>
              </li>
              <li>
                <span>Token Status</span>
                <strong>{adminBrokerAccount.tokenStatus}</strong>
              </li>
              <li>
                <span>Token Expiry</span>
                <strong>{adminBrokerAccount.tokenExpiry}</strong>
              </li>
              <li>
                <span>Last Refresh</span>
                <strong>{adminBrokerAccount.lastRefresh}</strong>
              </li>
            </ul>
            <div className="action-group">
              <button type="button" className="primary-button compact">
                Refresh Token
              </button>
              <button type="button" className="ghost-button compact">
                Reconnect Broker
              </button>
            </div>
          </article>

          <article className="info-card">
            <p className="eyebrow">Recent Activity</p>
            <h4>Admin notes</h4>
            <ul className="activity-list">
              {activityFeed.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>
        </div>
      </section>

      <section className="panel-section two-column">
        <div className="table-card">
          <div className="card-header">
            <div>
              <p className="eyebrow">Section 3</p>
              <h4>Strategy Management</h4>
            </div>
            <button type="button" className="ghost-button compact">
              Pause Strategy Globally
            </button>
          </div>
          <div className="strategy-grid">
            {strategies.map((strategy) => (
              <article key={strategy.id} className="strategy-card">
                <div className="strategy-topline">
                  <h5>{strategy.name}</h5>
                  <span className={`status-pill ${strategy.status.toLowerCase()}`}>
                    {strategy.status}
                  </span>
                </div>
                <p>{strategy.assignedUsers} users assigned</p>
                <p>Mode: {strategy.mode}</p>
                <div className="action-group">
                  <button type="button" className="primary-button compact">
                    Enable / Disable
                  </button>
                  <button type="button" className="ghost-button compact">
                    Pause Global
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>

        <article className="info-card">
          <p className="eyebrow">Section 4</p>
          <h4>Risk snapshot</h4>
          <div className="risk-grid single-column-grid">
            {riskControls.map((control) => (
              <article key={control.label} className={`risk-card ${control.tone}`}>
                <span>{control.label}</span>
                <strong>{control.value}</strong>
              </article>
            ))}
          </div>
        </article>
      </section>
    </>
  );
}

export default OverviewPage;
